import script from "./AdminAlbumList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAlbumList.vue?vue&type=script&setup=true&lang=js"

import "./AdminAlbumList.vue?vue&type=style&index=0&id=cee1d494&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee1d494"]])

export default __exports__